import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-369bc6c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gt-sm" }
const _hoisted_2 = {
  class: "bg-accent",
  style: {"min-height":"35px"}
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_5 = {
  id: "top-bar",
  class: "col-4 row justify-end",
  style: {"min-width":"350px"}
}
const _hoisted_6 = { class: "col-1" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "col-1" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  class: "col-1"
}
const _hoisted_11 = {
  class: "col-2",
  style: {"min-width":"60px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sep" }, "|", -1))
const _hoisted_13 = {
  class: "row Rotis items-center q-mt-sm q-mb-sm justify-between",
  style: {"min-height":"83px"}
}
const _hoisted_14 = {
  class: "col-3",
  style: {"width":"200px"}
}
const _hoisted_15 = { style: {"width":"200px"} }
const _hoisted_16 = {
  id: "page-bar",
  class: "col-8 q-pt-md"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 0,
  id: "search-bar",
  class: "col right q-pt-xs no-print",
  style: {"min-width":"60px"}
}
const _hoisted_21 = {
  id: "title-section",
  class: "print-bg q-mb-md header-img"
}
const _hoisted_22 = {
  class: "row",
  style: {"height":"250px"}
}
const _hoisted_23 = {
  class: "bg-white col-5 row items-end q-pb-lg q-px-md",
  style: {"opacity":"0.7"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_25 = { class: "min-col-7" }
const _hoisted_26 = { class: "col Rotis title-font" }
const _hoisted_27 = { class: "col Rotis text-secondary title-font subtitle-font" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-margin row",
  style: {"height":"76px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-5" }),
  /*#__PURE__*/_createElementVNode("div", { class: "col-7 bg-primary" })
], -1))
const _hoisted_29 = { class: "lt-md" }
const _hoisted_30 = { class: "row items-center" }
const _hoisted_31 = { class: "col no-print" }
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { class: "col right no-print" }
const _hoisted_34 = {
  id: "title-section",
  class: "print-bg q-mb-md"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-margin row bg-accent" }, null, -1))
const _hoisted_36 = { class: "row reverse bg-accent justify-end" }
const _hoisted_37 = { class: "col right q-px-md" }
const _hoisted_38 = { class: "col Rotis" }
const _hoisted_39 = { class: "col Rotis text-secondary" }
const _hoisted_40 = {
  key: 0,
  class: "q-ma-md"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "q-mr-md text-black" }, ">", -1))
const _hoisted_43 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "q-mr-md text-black" }, ">", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "q-mr-md text-black" }, ">", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideMenu = _resolveComponent("SideMenu")!
  const _component_QBtn = _resolveComponent("QBtn")!
  const _component_MainContent = _resolveComponent("MainContent")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_QIcon = _resolveComponent("QIcon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SideMenu, {
      showMenu: _ctx.showMenu,
      onCloseMenu: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMenu = false)),
      reloadPage: () => _ctx.reloadPage(_ctx.isReviewer ? '/requests' : '/home')
    }, null, 8, ["showMenu", "reloadPage"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_MainContent, { class: "q-pa-md no-padding" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("nav", _hoisted_5, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", _hoisted_6, [
                    _createElementVNode("a", {
                      href: _ctx.isReviewer ? '/requests' : '/home'
                    }, _toDisplayString(_ctx.$t("Header.FirstNavBar.HomeButton")), 9, _hoisted_7)
                  ]),
                  _createElementVNode("li", _hoisted_8, [
                    _createElementVNode("a", {
                      href: 'https://www.bbraun.ch/' + (_ctx.$i18n.locale === 'fr' ? 'fr' : 'de') + '/unternehmen/kontakt.html'
                    }, _toDisplayString(_ctx.$t("Header.FirstNavBar.ContactButton")), 9, _hoisted_9)
                  ]),
                  (_ctx.$router.currentRoute.value.name !== 'login' && _ctx.$router.currentRoute.value.name !== 'reset-password' && _ctx.$router.currentRoute.value.name !== 'privacy')
                    ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                        _createVNode(_component_QBtn, {
                          "no-caps": "",
                          flat: "",
                          class: "text-secondary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logOut())),
                          style: {"cursor":"pointer"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("Header.FirstNavBar.LogoutButton")), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("nav", _hoisted_11, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_QBtn, {
                      flat: "",
                      "no-caps": "",
                      label: "fr",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage('fr')))
                    })
                  ]),
                  _hoisted_12,
                  _createElementVNode("li", null, [
                    _createVNode(_component_QBtn, {
                      flat: "",
                      "no-caps": "",
                      label: "de",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeLanguage('de')))
                    })
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_MainContent, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                style: {"text-decoration":"none","cursor":"pointer"},
                onClick: _cache[4] || (_cache[4] = () => _ctx.reloadPage(_ctx.isReviewer ? '/requests' : '/home'))
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_q_img, {
                    src: require('@/assets/bbraun-logo.png'),
                    "spinner-color": "white",
                    style: {"height":"60px"},
                    fit: "cover"
                  }, null, 8, ["src"])
                ])
              ])
            ]),
            _createElementVNode("nav", _hoisted_16, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: 'https://www.bbraun.ch/' + (_ctx.$i18n.locale === 'fr' ? 'fr' : 'de') + '/produkte-und-therapien.html',
                    class: "text-primary"
                  }, _toDisplayString(_ctx.$t("Header.SecondNavBar.ProdukteUndTherapienButton")), 9, _hoisted_17)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: 'https://www.bbraun.ch/' + (_ctx.$i18n.locale === 'fr' ? 'fr' : 'de') + '/stories.html',
                    class: "text-primary"
                  }, _toDisplayString(_ctx.$t("Header.SecondNavBar.StoriesButton")), 9, _hoisted_18)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: 'https://www.bbraun.ch/' + (_ctx.$i18n.locale === 'fr' ? 'fr' : 'de') + '/unternehmen.html',
                    class: "text-primary"
                  }, _toDisplayString(_ctx.$t("Header.SecondNavBar.Companies")), 9, _hoisted_19)
                ])
              ])
            ]),
            (_ctx.$router.currentRoute.value.name !== 'login' && _ctx.$router.currentRoute.value.name !== 'reset-password')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.search) = $event)),
                    filled: "",
                    debounce: "500",
                    label: _ctx.$t('Header.SecondNavBar.SearchPlaceholder'),
                    color: "primary",
                    "label-color": "primary",
                    "bg-color": "accent",
                    onKeyup: _cache[7] || (_cache[7] = _withKeys(() => _ctx.goToSearchpage(), ["enter"]))
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_QIcon, {
                        name: "search",
                        color: "primary",
                        onClick: _cache[5] || (_cache[5] = () => _ctx.goToSearchpage()),
                        class: "all-pointer-events cursor-pointer"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("section", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t(_ctx.title).toUpperCase()), 1),
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t(_ctx.subtitle).toUpperCase()), 1)
            ])
          ])
        ]),
        _hoisted_28
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_QBtn, {
            flat: "",
            color: "white",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showMenu = true))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_QIcon, {
                name: "menu",
                color: "secondary"
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              style: {"text-decoration":"none","cursor":"pointer"},
              onClick: _cache[9] || (_cache[9] = () => _ctx.reloadPage(_ctx.isReviewer ? '/requests' : '/home'))
            }, [
              _createElementVNode("div", null, [
                _createVNode(_component_q_img, {
                  src: require('@/assets/bbraun-logo.png'),
                  "spinner-color": "white",
                  style: {"height":"60px"},
                  fit: "contain"
                }, null, 8, ["src"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_QBtn, {
            flat: "",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showSearchfield = !_ctx.showSearchfield))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_QIcon, {
                name: "search",
                color: "secondary"
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("section", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("h1", _hoisted_38, _toDisplayString(_ctx.$t(_ctx.title)), 1),
              _createElementVNode("h2", _hoisted_39, _toDisplayString(_ctx.$t(_ctx.subtitle)), 1)
            ])
          ])
        ])
      ]),
      (_ctx.showSearchfield)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createVNode(_component_q_input, {
              outlined: "",
              rounded: "",
              clearable: "",
              borderless: "",
              modelValue: _ctx.search,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.search) = $event)),
              onKeyup: _cache[12] || (_cache[12] = _withKeys(($event: any) => (_ctx.goToSearchpage()), ["enter"])),
              placeholder: _ctx.$t('Header.SecondNavBar.SearchPlaceholder')
            }, {
              append: _withCtx(() => [
                _createVNode(_component_QIcon, {
                  name: "search",
                  color: "secondary"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_MainContent, { class: "no-print" }, {
      default: _withCtx(() => [
        (_ctx.FirstTitle !== 'hide')
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createVNode(_component_QBtn, {
                class: "no-padding",
                flat: "",
                to: _ctx.isReviewer ? '/requests' : '/home',
                onClick: _cache[13] || (_cache[13] = () => { if (_ctx.isReviewer) _ctx.reloadPage('/requests') }),
                style: {"text-decoration":"none","width":"40px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_QIcon, {
                    color: "black",
                    name: "home"
                  })
                ]),
                _: 1
              }, 8, ["to"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bcTabUpdated?.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.index,
                  style: {"display":"inline-block"}
                }, [
                  (item.path !== 'none' && item.path !== 'back')
                    ? (_openBlock(), _createBlock(_component_QBtn, {
                        key: 0,
                        "text-color": "primary",
                        "no-caps": "",
                        onClick: ($event: any) => (_ctx.reloadPage(item.path)),
                        flat: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_42,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (item.path === 'none')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _hoisted_44,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (item.path === 'back')
                    ? (_openBlock(), _createBlock(_component_QBtn, {
                        key: 2,
                        "text-color": "primary",
                        "no-caps": "",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$router.go(-1))),
                        flat: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_45,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t(item.title)), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}